import { http_client } from "@/plugins/http_client";

const getTipoFormacion = async (param) => await http_client('/api/v1/formacion/persona/tipo-formacion',param,'get')
const getFormacionPersona = async (param) => await http_client('/api/v1/formacion/persona',param,'get')
const postFormacionPersona = async (body) => await http_client('/api/v1/formacion/persona',body,'post')
const putFormacionPersona = async (id_formacion_persona, body) => await http_client(`/api/v1/formacion/persona/${id_formacion_persona}`, body, 'put')
const deleteFormacionPersona = async (id_formacion_persona) => await http_client(`/api/v1/formacion/persona/${id_formacion_persona}`,{},'delete')

// Conocimiento persona
const getConocimientoPersona = async (params = {}) => await http_client('/api/v1/conocimiento/persona-conocimiento', params, 'get')
const getArchivoConocimientoPersona = async (id_conocimiento_persona) => await http_client(`/api/v1/conocimiento/persona-conocimiento/${id_conocimiento_persona}`, {}, 'get')
const postNivelConocimiento = async (body) => await http_client('/api/v1/conocimiento/persona-conocimiento', body, 'post')
const putNivelConocimiento = async (id_conocimiento_persona, body) => await http_client(`/api/v1/conocimiento/persona-conocimiento/${id_conocimiento_persona}`, body, 'put')
const deleteNivelConocimiento = async (id) => await http_client(`/api/v1/conocimiento/persona-conocimiento/${id}`,{},'delete')

// Experiencia persona
const getExperiencia = async (param) => await http_client('/api/v1/experiencia-laboral', param, 'get')
const postExperiencia = async (body) => await http_client('api/v1/experiencia-laboral', body, 'post')
const putExperiencia = async (id_experiencia, body) => await http_client(`/api/v1/experiencia-laboral/${id_experiencia}`, body, 'put')
const deleteExperiencia = async(id_experiencia) => await http_client(`/api/v1/experiencia-laboral/${id_experiencia}`,{},'delete')

export default {
    getTipoFormacion,
    getFormacionPersona,
    postFormacionPersona,
    putFormacionPersona,
    deleteFormacionPersona,
    getConocimientoPersona,
    getArchivoConocimientoPersona,
    postNivelConocimiento,
    putNivelConocimiento,
    deleteNivelConocimiento,
    getExperiencia,
    postExperiencia,
    putExperiencia,
    deleteExperiencia,
}
